// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3tXhw","buttons":"Footer_buttons__lBs1a"};